import { Injectable, RendererFactory2 } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DocumentService {
    private readonly documentClickSubject = new BehaviorSubject<Event | null>(
        null,
    );
    private readonly documentClick$ = this.documentClickSubject.asObservable();
    private readonly documentOnEscapeSubject =
        new BehaviorSubject<Event | null>(null);
    private readonly documentOnEscape$ =
        this.documentOnEscapeSubject.asObservable();

    constructor(private rendererFactory2: RendererFactory2) {
        const renderer = this.rendererFactory2.createRenderer(null, null);

        renderer.listen('document', 'click', (event: Event) => {
            this.documentClickSubject.next(event);
        });

        renderer.listen('document', 'keydown', (event: Event) => {
            const e = event as KeyboardEvent;

            if (e.key === 'Escape' && !e.shiftKey) {
                this.documentOnEscapeSubject.next(event);
            }
        });
    }

    onKeyDownEscape(): Observable<Event | null> {
        return this.documentOnEscape$;
    }

    onDocumentClick(): Observable<Event | null> {
        return this.documentClick$;
    }
}
